import { FormControl, Grid } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { gridSize } from '@/shared/constants';

export interface SampleDatePickerProps {
  label: string;
  onChange?: (date: string) => void;
  value?: string;
  defaultValue?: string;

  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };

  minDate?: Date | string;
  maxDate?: Date | string;

  display?: string;

  disabled?: boolean;

  views?: any[]
  format?: string
}

const SampleDatePickerNoForm: React.FC<SampleDatePickerProps> = ({
  label,
  onChange,
  value,
  defaultValue,
  size = gridSize,
  minDate,
  maxDate,
  display = 'flex',
  disabled = false,
  views = ['year', 'month', 'day'],
  format = 'YYYY-MM-DD'
}) => {
  const handleDateChange = (date: any) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    onChange && onChange(formattedDate);
  };

  return (
    <Grid
      item
      {...size}
      sx={{
        display: display,
      }}
    >
      <FormControl fullWidth>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={label}
            views={views}
            format={format}
            defaultValue={defaultValue ? dayjs(defaultValue) : null}
            value={value ? dayjs(value) : null}
            onChange={handleDateChange}
            minDate={minDate ? dayjs(minDate) : undefined}
            maxDate={maxDate ? dayjs(maxDate) : undefined}
            disabled={disabled}
          />
        </LocalizationProvider>
      </FormControl>
    </Grid>
  );
};

export default SampleDatePickerNoForm;
